import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches the list of POs with invoices that have status = stop
 * @returns {Promise} - API response containing list of POs with stopped invoices
 */
export const getPOsWithStoppedInvoices = async () => {
  try {
    const response = await apiClient.get(
      '/adminInvoiceManagement/invoice/pos-with-stopped-invoices'
    );

    // Handle the response structure: { status, message, response } or direct array
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }

    // Fallback to direct data if structure is different
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
